import { dehydrate } from "@tanstack/react-query";
import ConsensusPicksContainer from "@/components/container/HorseRacing/ConsensusPicksContainer";
import termsList from "@/constants/hr-terminology.json";
import { TermsT } from "@/types/horseRacing";
import { getRandomLearningTerms } from "@/utils/horseRacing";
import { loadHeader, loadUpcomingHorseRaces } from "@/utils/ssr";

interface ConsensusPicksProps {
  initialTerms: TermsT;
}

const SEO_TITLE = "Latest Horse Racing Consensus Picks, Odds & Predictions";
const SEO_DESCRIPTION =
  "Daily Horse Racing Consensus Picks, Predictions and Advice: In-Depth research on Horse Races all throughout the Horse Racing Calendar";

const ConsensusPicksPage = ({ initialTerms }: ConsensusPicksProps) => (
  <ConsensusPicksContainer
    initialTerms={initialTerms}
    title={SEO_TITLE}
    description={SEO_DESCRIPTION}
  />
);

export async function getServerSideProps() {
  const initialTerms = getRandomLearningTerms(termsList.terminology, 3);
  const menuClient = await loadHeader();
  const racesClient = await loadUpcomingHorseRaces(menuClient);
  return {
    props: {
      dehydratedState: dehydrate(racesClient),
      initialTerms,
      sportSlug: "horse-racing",
    },
  };
}

export default ConsensusPicksPage;
